import { withInstall } from '@zoryn/utils'
import Calendar from './src/calendar.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCalendar: SFCWithInstall<typeof Calendar> = withInstall(Calendar)
export default ZCalendar

export * from './src/calendar'
export type {
  CalendarDateTableInstance,
  DateTableInstance,
  CalendarInstance,
} from './src/instance'
